import GoSingleQueryCtl from "../../../../jsCom/comCtl/GoSingleQueryCtl";
import GoMoreQueryCtl from "../../../../jsCom/comCtl/GoMoreQueryCtl";
import dhtmlXCellObject from './dhtmlXCellObject';

dhtmlXCellObject.prototype.addSingleQueryCtl = function (rightToolBarId,searchFieldAry,vueObj,searchFun) {
    let newFieldAry = [];
    searchFieldAry.forEach(function (item) {
        if (item.query !== false) {
            newFieldAry.push(item);
        }
    });
    let ctl = new GoSingleQueryCtl(
        rightToolBarId,
        newFieldAry,
        vueObj,
        searchFun
    );
    return ctl;
};
dhtmlXCellObject.prototype.addMoreQueryCtl = function (rightToolBarId,searchFieldAry,vueObj,searchFun) {
    let moreCtl = new GoMoreQueryCtl(
        rightToolBarId,
        searchFieldAry,
        vueObj,
        searchFun
    );
    return moreCtl;
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXLayoutObject/dhtmlXCellObjectExtend.js